import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var FilterIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 14 15" }),
        React.createElement("path", { d: "M0.186163 1.41643C1.9633 3.69504 5.24485 7.91795 5.24485 7.91795V13.1966C5.24485 13.6805 5.64075 14.0764 6.12463 14.0764H7.88417C8.36805 14.0764 8.76394 13.6805 8.76394 13.1966V7.91795C8.76394 7.91795 12.0367 3.69504 13.8138 1.41643C14.2625 0.835784 13.849 0 13.1188 0H0.881183C0.150972 0 -0.262521 0.835784 0.186163 1.41643Z" })));
};

export { FilterIcon };
//# sourceMappingURL=FilterIcon.esm.js.map
